import ModalStack from '@/components/Custom/ModalStack';

export default function PrivateEventEventIdScorekeepingDeleteLayoutRoute() {
  return <ModalStack />;
}
